// TODO: two different - this was actually the field one!
export interface EffectivePermission {
  ModuleId: number
  CanRead: boolean
  CanUpdate: boolean
  CanCreate: boolean
  CanDelete: boolean
  CanExecute: boolean
}

export enum ResourcePermissionType {
  Unknown = 0,
  Owner = 1,
  Read = 2,
  ReadAndWrite = 3,
}

export enum ResourceType {
  Unknown = 0,
  SalesRep = 1,
  Customer = 2,
}

export interface ResourcePermission {
  Id: string;
  ResourceName: string;
  PermissionType: number;
  Type: number;
}

export interface User {
  Id?: number // TODO: always existing?
  Name: string
  LastName: string
  Username: string
  HasAccess: boolean
  SecurityToken?: string
  BearerToken?: string
  IsCodeToken: boolean
  EffectivePermissions: EffectivePermission[]
  Role: string
  TokenExpiration?: number
  ResourcePermissions: ResourcePermission[]
  loading?: boolean
  AuthProviderType: string
  Email: string
  AcceptanceDone: boolean
}

export interface ILoginRequest {
  Username: string
  Password: string
  Scope: string;
}

export interface IRecaptchaRequest {
  Challenge: string
}

export interface IPasswordResetRequest extends IRecaptchaRequest {
  Username: string
}

export interface ISignupRequest extends IRecaptchaRequest {
  Name: string
  LastName: string
  Email: string
  Password: string
  InvitationCode: string
  SalesRepIds: string[]
  CustomerNumbers: string[]
  Scope?: string
}

export interface IUpdatePasswordWithCodeRequest {
  Id: string
  Code: string
  NewPassword: string
}

export interface IChangePasswordRequest {
  UserName: string
  OldPassword: string
  NewPassword: string
}

// TODO: this should be in "editor" and "editor" should be "editor-edit"
export default interface State {
  error: boolean
  currentUser: User
  acceptanceUser: User
  loginCodeUser: User
  passwordExpired: boolean
  resetUsername: string
}

export interface IHttpError {
  Code: number
  CodeString: number
  Message: string
}

export interface ISecurity {
  currentUser: User
  error: boolean
}

export interface IUserAcceptance {
  siteDocumentId: number
  documentName: string
  accepted: boolean
}

export interface ISiteDocument {
  SiteDocumentId: number
  DocumentId: number
  AcceptanceDocumentTypeId: number
  DocumentName: string
  DocumentUrl: string
  Read: boolean
}

export enum Modules {
  None = 0,
  Product = 1,
  Topology = 5,
  Request = 6,
  Inventory = 7,
  ConfigurableMaterial = 10,
  Export = 13,
  LegacyAdmin = 190,
  InquiryAdmin = 191,
  OrderAdmin = 192,
  SalesRepAdmin = 193,
  CustomerAdmin = 194,
  UserAdmin = 195,
}
